import { z } from 'zod';
import { idSchema } from './common.js';
/**
 * Schnellerfassung (SPEC 9.5).
 *
 * Uebertragen wird der Rohtext, nicht das Ergebnis der Auswertung im Browser.
 * Der Server wertet mit demselben geteilten Modul aus — dadurch kann die
 * Vorschau nicht von dem abweichen, was tatsaechlich entsteht.
 */
export const quickCaptureSchema = z.object({
    text: z.string().min(1, 'Text ist Pflicht').max(500),
    columnId: idSchema,
});
//# sourceMappingURL=quick-capture.js.map